import { addDeploymentRepoSecret, provisionDeploymentRepo } from "../api";
import { GhaOptions } from "../types";

/**
 * Creates a Semgrep App secret for each repo and commits the GHA file
 *
 * @param orgId id of org
 * @param repoFullNames full names of repos to add secret and commit to
 * @param onError function that runs on error
 * @param refetchRepos function that runs on success to refresh repos, since repos should have started scanning
 * @param ghaOptions options for GitHub actions file
 */
export const createSecretsAndCommitToRepos = async (
  orgId: string,
  repoFullNames: string[],
  onError: () => void,
  refetchRepos: () => void,
  ghaOptions: GhaOptions
) => {
  return Promise.all(
    repoFullNames.map((r) => addDeploymentRepoSecret(orgId, r))
  )
    .then(() =>
      Promise.all(
        repoFullNames.map((r) =>
          provisionDeploymentRepo(orgId, r, { gha_options: ghaOptions })
        )
      )
    )
    .catch(() => {
      onError();
    })
    .then(() => {
      // refetch repos since scans should have started
      refetchRepos();
    });
};
